import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { InvoiceSimilarListProps } from "models/propTypes/invoicePropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { Amount } from "models/utilTypes/currencyType";
//#endregion
//#region components
import { ViewPanel, useMountedState, TableAsync, Tags, SubTitleWithIcon } from "components/common";
import InvoiceStatusTags from "./statusTags";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import { useNavigate, useLocation } from "react-router-dom";

const InvoiceSimilarList: React.FC<InvoiceSimilarListProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { getMounted } = useMountedState();
  const location = useLocation();
  const navigate = useNavigate();

  const [invoices, setInvoices] = React.useState<WintSuperkollAPIModel.InvoiceSimilarItem[]>();

  React.useEffect(() => {
    invoiceService.getSimilarInvoices(props.id).then((result) => {
      getMounted() && setInvoices(result);
    });
  }, [props.id]);

  const onRowClick = (row: WintSuperkollAPIModel.InvoiceSimilarItem) => {
    navigate(UrlHelper.formatPath(`/Invoice/${row.id}`), {
      state: { background: location },
    });
  };

  return (
    <>
      {invoices && invoices.length > 0 && (
        <ViewPanel
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Similar)}
          icon={IconDefinitionConstants.WDocument}
        >
          <>
            <SubTitleWithIcon
              subTitle={LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.Common.SimilarSuggestionText,
                undefined,
                { itemCount: `${invoices.length}` }
              )}
              icon={IconDefinitionConstants.WBolt}
            ></SubTitleWithIcon>
            <TableAsync<WintSuperkollAPIModel.InvoiceSimilarItem>
              properties={{
                date: {
                  description: TranslationKeys.Common.Date,
                  formatter: (values: WintSuperkollAPIModel.InvoiceSimilarItem) => values.date && new Date(values.date),
                  noWrap: true,
                },
                receiver: {
                  description: TranslationKeys.Common.Receiver,
                },
                amount: {
                  description: TranslationKeys.Common.Amount,
                  formatter: (values: WintSuperkollAPIModel.InvoiceSimilarItem) =>
                    new Amount(values.currency, values.amount),
                  alignment: "right",
                  className: cssExports.textBlack,
                },
                status: {
                  description: TranslationKeys.Common.Status,
                  formatter: (values: WintSuperkollAPIModel.InvoiceSimilarItem) => (
                    <InvoiceStatusTags status={values.status} />
                  ),
                },
                dimensions: {
                  description: TranslationKeys.Common.Dimensions,
                  formatter: (values: WintSuperkollAPIModel.InvoiceSimilarItem) => (
                    <Tags tags={values.dimensions ?? []} maxDisplayCount={2} />
                  ),
                },
              }}
              filter={invoices}
              rowClickHandler={onRowClick}
              pagination={false}
            />
          </>
        </ViewPanel>
      )}
    </>
  );
};

export default InvoiceSimilarList;
